import { useShapeLibrary } from "../hooks/use-shape-library";
import ShapeMenuIcon from "../shape-menu-icon";
import { ShapeInfo } from "../side-panel/virtualized-list/virtualized-row";
import styles from "./next-element-menu.module.css";
import { LibraryRow } from "./types";

interface RowProps {
  data: LibraryRow;
  style: React.CSSProperties;
  onMenuItemClick: (elementType: string, elementData: Record<string, unknown>, elementInfo: ShapeInfo) => void;
}

function ItemRow({ style, data, onMenuItemClick }: RowProps) {
  const {
    data: { thumbnails, mappings },
    isLoading,
    error, // Errors should occur in the parent component, but we handle them here just in case.
  } = useShapeLibrary(data.libraryId, true);

  const iconSize = 25;
  const iconPadding = 4;
  const icons = data.items ?? [];

  if (isLoading || error) {
    return (
      <div style={style} className={styles.itemRow}>
        {icons.map((_, index) => (
          <div
            key={index}
            className={styles.skeleton}
            style={{ width: iconSize, height: iconSize, margin: iconPadding }}
          />
        ))}
      </div>
    );
  }

  return (
    <div style={style} className={styles.itemRow}>
      {icons.map((icon, index) => {
        const { elementType, elementData } = mappings[icon.id];
        const iconInfo: ShapeInfo = {
          library: data.libraryId,
          group: data.groupId ?? "",
          item: icon.id,
        };

        const onClick = () => {
          return onMenuItemClick(elementType, elementData, iconInfo);
        };

        return (
          <div key={index}>
            <ShapeMenuIcon
              shapeId={icon.id}
              displayName={icon.displayName}
              onMouseDown={onClick}
              thumbnail={thumbnails[icon.id]}
              size={iconSize}
              padding={iconPadding}
            />
          </div>
        );
      })}
    </div>
  );
}

export default function NextElementMenuRow({
  index,
  style,
  data,
}: {
  index: number;
  style: React.CSSProperties;
  data: {
    rows: LibraryRow[];
    onMenuItemClick: (elementType: string, elementData: Record<string, unknown>, elementInfo: ShapeInfo) => void;
  };
}) {
  const row = data.rows[index];
  const rowProps: RowProps = {
    data: row,
    style,
    onMenuItemClick: data.onMenuItemClick,
  };

  return <ItemRow {...rowProps} />;
}
